export const ProductCategoryFormStages = [
  {
    title: "Category",
    sections: [
      {
        name: "",
        fields: [
          {
            name: "g4b_name",
            description: "",
            isNameField: true,
            label: "Name",
            required: true,
            type: "nvarchar",
          },
          {
            name: "g4b_code",
            description: "",
            label: "Code",
            type: "nvarchar",
          },
          {
            name: "g4b_description",
            description: "",
            label: "Description",
            type: "nvarchar",
          },
          {
            name: "g4b_sequence",
            description: "",
            label: "Sequence",
            type: "int",
          },
        ],
      },
    ],
  },
];
